import {
  hidePositionsLoader,
  setGroups,
  setPositions,
  setPositionsForId,
  showPositionsLoader,
} from "./actions";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  deletePositions,
  getPositionsByPosId,
  getPositions,
  patchPositions,
  getGroups,
  postPositions,
} from "../../helpers/jwt_helper.js";
import {
  GET_POSITIONS,
  DELETE_POSITIONS,
  ADD_POSITIONS,
  GET_POSITIONS_FOR_ID,
  PATCH_POSITIONS,
  GET_GROUPS,
} from "./actionType";
import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetPositions({ payload: data }) {
  try {
    yield put(showPositionsLoader());
    let response = yield call(getPositions, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      title: data.title || "",
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }
    yield put(setPositions(response));
    yield put(hidePositionsLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePositionsLoader());
  }
}

function* onGetGroups() {
  try {
    let res = yield call(getGroups);
    yield put(setGroups(res));
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePositionsLoader());
  }
}

function* onPostPositions({ payload: { position, data } }) {
  try {
    let post_req = {
      title: position.title,
      description: position.description,
      groups: position.groups,
      rate: position.rate,
    };
    yield put(showPositionsLoader());
    let res = yield call(postPositions, post_req);
    yield call(onGetPositions, { payload: data });
    yield call(onGetPositionsDataForId, { payload: { id: res.id } });
    yield put(hidePositionsLoader());
    showSuccessMessage(
      `Added position ${position.title} has been successfully`
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePositionsLoader());
  }
}

function* onGetPositionsDataForId({ payload: { id } }) {
  try {
    yield put(showPositionsLoader());
    let res = yield call(getPositionsByPosId, id);
    yield put(setPositionsForId(res));
    yield put(hidePositionsLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePositionsLoader());
  }
}

function* onPatchPositions({ payload: { id, update, data } }) {
  try {
    yield put(showPositionsLoader());
    yield call(patchPositions, id, update);
    yield call(onGetPositions, { payload: data });
    yield call(onGetPositionsDataForId, { payload: { id } });
    yield put(hidePositionsLoader());
    showSuccessMessage(`Updating position ${id} has been successfully`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePositionsLoader());
  }
}

function* onDeletePositions({ payload: { id, data } }) {
  try {
    yield put(showPositionsLoader());
    yield call(deletePositions, id);
    yield call(onGetPositions, { payload: data });
    showSuccessMessage(`Deleting position ${id} has been successfully`);
  } catch (e) {
    yield put(hidePositionsLoader());
    showErrorMessage(getErrorMessage(e));
  }
}

function* PositionsSaga() {
  yield takeEvery(PATCH_POSITIONS, onPatchPositions);
  yield takeEvery(GET_POSITIONS_FOR_ID, onGetPositionsDataForId);
  yield takeEvery(GET_POSITIONS, onGetPositions);
  yield takeEvery(DELETE_POSITIONS, onDeletePositions);
  yield takeEvery(GET_GROUPS, onGetGroups);
  yield takeEvery(ADD_POSITIONS, onPostPositions);
}

export default PositionsSaga;
